import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {HttpClient} from '@angular/common/http';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/share';
import {User} from '../models/user.model';

@Injectable()
export class UserService {
  private currentUser: User;

  constructor(private http: HttpClient) {
  }

  getCurrentUser(): Observable<User> {
    return this.currentUser
      ? Observable.of(this.currentUser)
      : this.http.get('/auth/user').share().map((data: any) => {
        if (data.success) {
          this.currentUser = User.fromResponse(data.profile);
        }
        return this.currentUser;
      });
  }
}



// WEBPACK FOOTER //
// D:/Projects/bid/frontend/src/app/shared/services/user.service.ts